import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SupplierInboxJobsService } from 'src/app/services/supplier-inbox-jobs.service';
import { MessageService, SelectItem } from 'primeng';
import { InputHelper } from '../../../utils/input.helper';
import { AssignTruckTask } from '../../../interfaces/assign-truck-task';

@Component({
  selector: 'allocate-truck-dialog',
  templateUrl: './allocate-truck-dialog.component.html',
  styleUrls: ['./allocate-truck-dialog.component.scss'],
})
export class AllocateTruckDialogComponent {
  @Input() visible: boolean = false;

  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Output() truckAllocated: EventEmitter<number> = new EventEmitter<number>();

  @Input() jobId: number;

  selectedTruckId: number;

  selectedTask: AssignTruckTask;

  loading: boolean;

  supplierTrucks: SelectItem[] = [];

  tasks: AssignTruckTask[] = [];

  constructor(
    private supplierInboxJobsService: SupplierInboxJobsService,
    public messageService: MessageService,
    public inputHelper: InputHelper,
  ) {}

  async onShow() {
    this.loading = true;

    const trucks = (await this.supplierInboxJobsService.getSupplierUserTrucks()) || [];

    this.supplierTrucks = trucks.map((d) => ({
      label: `${d.make} ${d.model} (${d.registration})`,
      value: d.id,
    }));

    this.tasks = (await this.supplierInboxJobsService.getNoTrucksJobTasks(this.jobId)) || [];

    this.loading = false;
  }

  async allocateTruck() {
    await this.supplierInboxJobsService.allocateTruck(this.selectedTask.id, this.selectedTruckId);

    this.truckAllocated.emit(this.selectedTruckId);
    this.visibleChange.emit(false);
  }

  asAssignTruckTask(itemUntyped: any): AssignTruckTask {
    return itemUntyped as AssignTruckTask;
  }
}
